export const getStats: (peerConnection: RTCPeerConnection) => void = (peerConnection) =>
	peerConnection.getStats();
